export interface IntermediateStats {
  viewPath: string
  timeSpentMs: number
  eventIds: string[]
}

export interface PageStats {
  viewKey: string
  timeSpentMs: number
  visitCount: number
  lastVisited: string
}

export interface Report {
  userName: string
  reportCreatedAt: Date
  timeMs: number
  timeSpentMsDb?: number
  timeSeconds: number
  timeMinutes: number
  pageStats: PageStats[]
  breakdown: BreakdownPageStat
  events: UserEvents[]
}

export enum TimeRangePreset {
  TODAY = 'today',
  LAST_7_DAYS = 'last-7-days',
  LAST_30_DAYS = 'last-30-days',
  LAST_90_DAYS = 'last-90-days',
  LAST_YEAR = 'last-year',
  ALL_TIME = 'all-time',
}

export interface TimeFilterProps {
  startTime?: Date | null
  endTime?: Date | null
  onStartDateChange: (date?: Date | null) => void
  onEndDateChange: (date?: Date | null) => void
  onPresetChange: (preset: TimeRangePreset) => void
  userIdOrEmail: string
  setUserIdOrEmail: (value: string) => void
  showUserFilter?: boolean
}

export interface BreakdownPageStat {
  viewKey: string
  viewName: string

  timeSpentPageMs: number
  timeSpentModuleMs: number

  visitCountPage: number
  visitCountModule: number

  lastVisitedPageDate: string | null
  lastVisitedModuleDate: string | null

  subViews?: { [viewName: string]: BreakdownPageStat }
  children?: BreakdownPageStat[]
}

export interface UserEvents {
  id: string
  userId: number
  eventName: string
  viewportId: string
  viewKey: string
  extra: { [key: string]: unknown }

  createdAt: string
}

export interface learningStats {
  activities: {
    correctAnswers: number
    wrongAnswers: number
    noActivities: boolean
  }
  timeSpent: number
  funFactChests: number
  videoWatchDuration: number
  videoWatchCount: number
}
